<template>
  <Card>
    <template #title="">ไม่พบหน้าที่คุณต้องการ</template>
    <template #content="">
      
    </template>
    <template #footer="">
      <Button
        @click="goHome"
        icon="pi pi-home"
        label="กลับไปยังหน้าหลัก"
      ></Button>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "NotFound",
  setup() {
    const { onRouterPush } = usePlugin();
    const goHome = () => {
      onRouterPush({ name: "home" });
    };
    return { goHome };
  },
});
</script>

<style></style>
